export default __webpack_public_path__ + "static/logo-color-new-da59482ec8ae16aee35ceb2d95a6e1cf.svg";